import "./registerServiceWorker";
import { applyPolyfills } from "@/modules/polyfills";
import createApp from "@/main";

applyPolyfills()
  .then(() => createApp())
  .then(({ app }) => app.$mount("#app"));
